class BlockQuoteImage {
	constructor() {
		this.quotes = document.querySelectorAll(".quote-text");
		if (this.quotes) {
			// Pour attendre le chargement des fonts avant de splitter le texte
			window.addEventListener('load', () => {
				this.buildQuotes();
			});
			resizeCallbacks.push(this);
		}
	}

	buildQuotes() {
		this.quotesSplit = [];
		this.quotes.forEach((quote, index) => {
			this.quotesSplit[index] = new SplitText(quote, {
				type: "lines, words, chars",
				linesClass: "line",
				wordsClass: "word"

			});
		});
	}

	resize() {
		this.quotesSplit.forEach(item => {
			item.revert();
		});
		this.buildQuotes();
	}
}